export const LOGIN = 'APP_LOGIN'
export const LOGINAS = 'APP_LOGINAS'
export const LOGOUT = 'APP_LOGOUT'
export const INIT = 'APP_INIT'
export const WHOAMI = 'APP_WHOAMI'



// WEBPACK FOOTER //
// ./src/store/account/mutations-type.js